import React from "react"

export const Auth = React.createContext({
  isAuthentificated: false,
  setIsAuthentificated: (value: any) => {},
})
